import type { Locale } from './locales';

export type TextDirection = 'ltr' | 'rtl';

/**
 * The only locale requiring right-to-left layout at MVP is Arabic (PDF §27,
 * DEV §13). Every ui-kit component reads this rather than hardcoding a
 * direction, so adding a future RTL locale is a one-line change here rather
 * than a search-and-replace across components.
 */
const RTL_LOCALES: ReadonlySet<Locale> = new Set(['ar']);

export function directionFor(locale: Locale): TextDirection {
  return RTL_LOCALES.has(locale) ? 'rtl' : 'ltr';
}

export function isRtl(locale: Locale): boolean {
  return directionFor(locale) === 'rtl';
}
